(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-context/assets/javascripts/use-draws.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-context/assets/javascripts/use-draws.js');
"use strict";


const CompetitionContext = svs.components.marketplaceCompetition.competitionContext.CompetitionContext;
const _React = React,
  useContext = _React.useContext;
const logger = svs.core.log.getLogger('marketplace-competition:use-draws');

const useDrawsViaContext = _ref => {
  let drawNumbers = _ref.drawNumbers,
    _ref$productId = _ref.productId,
    productId = _ref$productId === void 0 ? null : _ref$productId;
  const context = useContext(CompetitionContext);
  if (context === undefined) {
    logger.info("Mkp-competition: context undefined, use-draws.es6");
    throw new Error('useDrawsViaContext must be used within a CompetitionProvider');
  }
  return context.useDraws({
    drawNumbers,
    productId
  });
};

setGlobal('svs.components.marketplaceCompetition.competitionContext.useDrawsViaContext', useDrawsViaContext);

 })(window);